
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { int32ToString, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Msg, StocktakingListTableRow, SelectedTab } from "./Types.js";
import { empty as empty_1, choose, append, map as map_1, head, tail, isEmpty, singleton, reduce, toArray, ofArray, length } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SuccessAlert } from "../../Components/Alert.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import Check from "../../../public/assets/icons/Check.svg";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { StocktakingId__get_unwrap, LabelId, ConsumableId__get_unwrap, ToolId__get_unwrap } from "../../Shared/Shared.js";
import { unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Label as Label_3 } from "../../Shared/Category.js";
import { append as append_1, empty, singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Qr_Code from "../../../public/assets/icons/Qr_Code.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import { StocktakingState, StocktakingResultType } from "../../Shared/Stocktaking.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { ConfirmStocktakingResultDialog } from "../Dialog/ConfirmStocktakingResultDialog.js";
import { CorrectionBookingDialog } from "../Dialog/CorrectionBookingDialog.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { ChangelogTable } from "../../Widgets/Table/ChangelogTable.js";
import { TextValue } from "../../Components/Text.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";
import Shipment_Time from "../../../public/assets/icons/Shipment_Time.svg";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function StocktakingListTable(props) {
    let elems, TableRows, Options;
    const t = useTranslation()[0];
    if (equals(props.SelectedTab, new SelectedTab(0, [])) && (length(props.Rows) === 0)) {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems = [createElement(SuccessAlert, {
            Label: t("stocktaking.no_required_actions"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return createElement(InfiniteTable, (TableRows = toArray(props.Rows), (Options = {
            BorderStyle: "row",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "multiRow",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: [new ColumnDefinition$1("status_icon", "", t("stocktaking.status"), (dto) => {
                let matchValue, elems_3, elems_1, elems_2;
                return new CellContent(1, [(dto.RecordedBy != null) ? ((matchValue = dto.RecordedQuantity, (matchValue == null) ? reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_3 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))) : ((matchValue === dto.Quantity) ? reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_1 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))) : reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems_2 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))))) : defaultOf()]);
            }, "none", "text"), new ColumnDefinition$1("image", "", t("general.image"), (dto_1) => (new CellContent(4, [dto_1.ImageUrl])), "none", "image"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (dto_2) => (new CellContent(0, [dto_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("name", "", t("general.name"), (dto_3) => (new CellContent(2, [dto_3.Name, () => {
                const matchValue_1 = dto_3.StocktakingResultType;
                switch (matchValue_1.tag) {
                    case 0: {
                        RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                        break;
                    }
                    case 1: {
                        RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                        break;
                    }
                    default:
                        RouterModule_nav(ofArray(["consumables", ConsumableId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                }
            }])), "text", "button"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (dto_4) => (new CellContent(0, [dto_4.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (dto_5) => (new CellContent(0, [dto_5.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("general.serial_number"), (dto_6) => (new CellContent(0, [dto_6.SerialNumber])), "text", "text"), new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (dto_7) => (new CellContent(0, [(length(dto_7.QRCodeIds) > 0) ? reduce((output, code) => concat(code, ", ", ...output), dto_7.QRCodeIds) : ""])), "text", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_8) => (new CellContent(0, [dto_8.Quantity])), "text", "text"), new ColumnDefinition$1("unit", "", t("general.unit"), (dto_9) => (new CellContent(0, [dto_9.Unit])), "select", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (dto_10) => (new CellContent(0, [dto_10.StorageSpace])), "select", "text"), new ColumnDefinition$1("recordedBy", "", t("stocktaking.recorded_by"), (dto_11) => (new CellContent(0, [defaultArg(dto_11.RecordedBy, "")])), "select", "text"), new ColumnDefinition$1("recordTimestamp", "", t("stocktaking.record_timestamp"), (dto_12) => (new CellContent(0, [defaultArg(map((timestamp) => toString(toLocalTime(timestamp), "dd.MM.yyyy HH:mm"), dto_12.RecordTimestamp), "")])), "none", "text"), new ColumnDefinition$1("recordedQuantity", "", t("stocktaking.recorded_quantity"), (dto_13) => (new CellContent(0, [defaultArg(dto_13.RecordedQuantity, "")])), "text", "text"), new ColumnDefinition$1("correctedBy", "", t("stocktaking.corrected_by"), (dto_14) => (new CellContent(0, [defaultArg(dto_14.CorrectedBy, "")])), "select", "text"), new ColumnDefinition$1("correctionTimestamp", "", t("stocktaking.correction_timestamp"), (dto_15) => (new CellContent(0, [defaultArg(map((timestamp_1) => toString(toLocalTime(timestamp_1), "dd.MM.yyyy HH:mm"), dto_15.CorrectionTimestamp), "")])), "none", "text"), new ColumnDefinition$1("correctionQuantity", "", t("stocktaking.correction_quantity"), (dto_16) => (new CellContent(0, [defaultArg(dto_16.CorrectionQuantity, "")])), "text", "text"), new ColumnDefinition$1("isToolWithQuantity", t("general.master_data"), t("general.tool_type"), (dto_17) => {
                let matchValue_2;
                return new CellContent(3, [(matchValue_2 = dto_17.StocktakingResultType, (matchValue_2.tag === 1) ? singleton(new Label_3(new LabelId("00000000-0000-0000-0000-000000000000"), t("general.tool_with_quantity"), "#000000", true, undefined)) : ((matchValue_2.tag === 2) ? singleton(new Label_3(new LabelId("00000000-0000-0000-0000-000000000000"), t("general.consumable"), "#9A9FFF", true, undefined)) : singleton(new Label_3(new LabelId("00000000-0000-0000-0000-000000000000"), t("general.tool"), "#14BC9C", true, undefined))))]);
            }, "select", "text")],
            Controls: toList(delay(() => {
                const matchValue_3 = props.Stocktaking.State;
                switch (matchValue_3.tag) {
                    case 2: {
                        const matchValue_4 = props.StocktakingList.State;
                        switch (matchValue_4.tag) {
                            case 1:
                                return singleton_1(new TableControlElement$1(0, [new TableControl$1(t("stocktaking.add_result"), Qr_Code(), (value_14) => {
                                    let matchResult, selectedElement;
                                    if (!isEmpty(value_14)) {
                                        if (isEmpty(tail(value_14))) {
                                            matchResult = 0;
                                            selectedElement = head(value_14);
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                    switch (matchResult) {
                                        case 0: {
                                            props.SetIsConfirmStocktakingResultDialogOpen(selectedElement.StocktakingResultType);
                                            break;
                                        }
                                        case 1: {
                                            break;
                                        }
                                    }
                                }, true, false, "stocktaking-assign-helper-to-list")]));
                            default: {
                                return empty();
                            }
                        }
                    }
                    case 3:
                        return singleton_1(new TableControlElement$1(0, [new TableControl$1(t("stocktaking.do_correction_booking"), Qr_Code(), (values) => {
                            props.SetIsCorrectionBookingDialogOpen(map_1((value_15) => value_15.StocktakingResultType, values));
                        }, true, false, "stocktaking-assign-helper-to-list")]));
                    default: {
                        return empty();
                    }
                }
            })),
            Options: Options,
            TableKey: "stocktaking-list",
            TableRows: TableRows,
        })));
    }
}

export function StocktakingListOverviewSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setIsConfirmStocktakingResultDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsCorrectionBookingDialogOpen = patternInput_2[1];
    let patternInput_3;
    let initial_2;
    const matchValue = props.Stocktaking.State;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 4: {
            initial_2 = (new SelectedTab(0, []));
            break;
        }
        default:
            initial_2 = (new SelectedTab(1, []));
    }
    patternInput_3 = reactApi.useState(initial_2);
    const setSelectedTab = patternInput_3[1];
    const selectedTab = patternInput_3[0];
    const overviewRows = append(choose((stocktakingListTool) => (new StocktakingListTableRow(stocktakingListTool.ImageUrl, stocktakingListTool.InventoryNumber, "", stocktakingListTool.DisplayName, stocktakingListTool.Manufacturer, stocktakingListTool.Model, stocktakingListTool.SerialNumber, stocktakingListTool.QRCodeIds, stocktakingListTool.StorageSpace, "1", map((_arg) => _arg.RecordedBy, stocktakingListTool.Result), map((_arg_1) => _arg_1.Timestamp, stocktakingListTool.Result), map((result) => {
        if (result.Existing) {
            return "1";
        }
        else {
            return "0";
        }
    }, stocktakingListTool.Result), map((_arg_2) => _arg_2.CorrectedBy, stocktakingListTool.Correction), map((_arg_3) => _arg_3.Timestamp, stocktakingListTool.Correction), undefined, new StocktakingResultType(0, [stocktakingListTool.ToolId]))), props.StocktakingList.Tools), append(choose((stocktakingListToolWithQuantity) => (new StocktakingListTableRow(stocktakingListToolWithQuantity.ImageUrl, stocktakingListToolWithQuantity.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity.DisplayName, stocktakingListToolWithQuantity.Manufacturer, stocktakingListToolWithQuantity.Model, "", stocktakingListToolWithQuantity.QRCodeIds, stocktakingListToolWithQuantity.StorageSpace, int32ToString(stocktakingListToolWithQuantity.Quantity), map((_arg_5) => _arg_5.RecordedBy, stocktakingListToolWithQuantity.Result), map((_arg_6) => _arg_6.Timestamp, stocktakingListToolWithQuantity.Result), map((arg) => int32ToString(arg.Quantity), stocktakingListToolWithQuantity.Result), map((_arg_8) => _arg_8.CorrectedBy, stocktakingListToolWithQuantity.Correction), map((_arg_9) => _arg_9.Timestamp, stocktakingListToolWithQuantity.Correction), map((arg_1) => int32ToString(arg_1.Quantity), stocktakingListToolWithQuantity.Correction), new StocktakingResultType(1, [stocktakingListToolWithQuantity.ToolId]))), props.StocktakingList.ToolsWithQuantity), choose((stocktakingListConsumable) => (new StocktakingListTableRow(stocktakingListConsumable.ImageUrl, stocktakingListConsumable.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable.Unit)), stocktakingListConsumable.ConsumableName, "", "", "", stocktakingListConsumable.QRCodeIds, stocktakingListConsumable.StorageSpace, stocktakingListConsumable.Quantity.toString(), map((_arg_12) => _arg_12.RecordedBy, stocktakingListConsumable.Result), map((_arg_13) => _arg_13.Timestamp, stocktakingListConsumable.Result), map((arg_2) => arg_2.Quantity.toString(), stocktakingListConsumable.Result), map((_arg_15) => _arg_15.CorrectedBy, stocktakingListConsumable.Correction), map((_arg_16) => _arg_16.Timestamp, stocktakingListConsumable.Correction), map((arg_3) => arg_3.Quantity.toString(), stocktakingListConsumable.Correction), new StocktakingResultType(2, [stocktakingListConsumable.ConsumableId]))), props.StocktakingList.Consumables)));
    const requiredActionsRows = append(choose((stocktakingListTool_1) => {
        let result_1;
        const matchValue_1 = stocktakingListTool_1.Result;
        const matchValue_2 = stocktakingListTool_1.Correction;
        let matchResult, result_2;
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                matchResult = 2;
            }
            else if ((result_1 = matchValue_1, equals(props.Stocktaking.State, new StocktakingState(3, [])) && !result_1.Existing)) {
                matchResult = 1;
                result_2 = matchValue_1;
            }
            else {
                matchResult = 2;
            }
        }
        else if (matchValue_2 != null) {
            matchResult = 2;
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return new StocktakingListTableRow(stocktakingListTool_1.ImageUrl, stocktakingListTool_1.InventoryNumber, "", stocktakingListTool_1.DisplayName, stocktakingListTool_1.Manufacturer, stocktakingListTool_1.Model, stocktakingListTool_1.SerialNumber, stocktakingListTool_1.QRCodeIds, stocktakingListTool_1.StorageSpace, "", undefined, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(0, [stocktakingListTool_1.ToolId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListTool_1.ImageUrl, stocktakingListTool_1.InventoryNumber, "", stocktakingListTool_1.DisplayName, stocktakingListTool_1.Manufacturer, stocktakingListTool_1.Model, "", stocktakingListTool_1.QRCodeIds, stocktakingListTool_1.StorageSpace, "1", result_2.RecordedBy, result_2.Timestamp, "0", undefined, undefined, undefined, new StocktakingResultType(0, [stocktakingListTool_1.ToolId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.Tools), append(choose((stocktakingListToolWithQuantity_1) => {
        let result_3;
        const matchValue_4 = stocktakingListToolWithQuantity_1.Result;
        const matchValue_5 = stocktakingListToolWithQuantity_1.Correction;
        let matchResult_1, result_4;
        if (matchValue_4 != null) {
            if (matchValue_5 != null) {
                matchResult_1 = 2;
            }
            else if ((result_3 = matchValue_4, equals(props.Stocktaking.State, new StocktakingState(3, [])) && (result_3.Quantity !== stocktakingListToolWithQuantity_1.Quantity))) {
                matchResult_1 = 1;
                result_4 = matchValue_4;
            }
            else {
                matchResult_1 = 2;
            }
        }
        else if (matchValue_5 != null) {
            matchResult_1 = 2;
        }
        else {
            matchResult_1 = 0;
        }
        switch (matchResult_1) {
            case 0:
                return new StocktakingListTableRow(stocktakingListToolWithQuantity_1.ImageUrl, stocktakingListToolWithQuantity_1.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity_1.DisplayName, stocktakingListToolWithQuantity_1.Manufacturer, stocktakingListToolWithQuantity_1.Model, "", stocktakingListToolWithQuantity_1.QRCodeIds, stocktakingListToolWithQuantity_1.StorageSpace, int32ToString(stocktakingListToolWithQuantity_1.Quantity), undefined, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(1, [stocktakingListToolWithQuantity_1.ToolId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListToolWithQuantity_1.ImageUrl, stocktakingListToolWithQuantity_1.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity_1.DisplayName, stocktakingListToolWithQuantity_1.Manufacturer, stocktakingListToolWithQuantity_1.Model, "", stocktakingListToolWithQuantity_1.QRCodeIds, stocktakingListToolWithQuantity_1.StorageSpace, int32ToString(stocktakingListToolWithQuantity_1.Quantity), map((_arg_20) => _arg_20.RecordedBy, stocktakingListToolWithQuantity_1.Result), map((_arg_21) => _arg_21.Timestamp, stocktakingListToolWithQuantity_1.Result), map((arg_4) => int32ToString(arg_4.Quantity), stocktakingListToolWithQuantity_1.Result), map((_arg_23) => _arg_23.CorrectedBy, stocktakingListToolWithQuantity_1.Correction), map((_arg_24) => _arg_24.Timestamp, stocktakingListToolWithQuantity_1.Correction), map((arg_5) => int32ToString(arg_5.Quantity), stocktakingListToolWithQuantity_1.Correction), new StocktakingResultType(1, [stocktakingListToolWithQuantity_1.ToolId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.ToolsWithQuantity), choose((stocktakingListConsumable_1) => {
        let result_5;
        const matchValue_7 = stocktakingListConsumable_1.Result;
        const matchValue_8 = stocktakingListConsumable_1.Correction;
        let matchResult_2, result_6;
        if (matchValue_7 != null) {
            if (matchValue_8 != null) {
                matchResult_2 = 2;
            }
            else if ((result_5 = matchValue_7, equals(props.Stocktaking.State, new StocktakingState(3, [])) && (result_5.Quantity !== stocktakingListConsumable_1.Quantity))) {
                matchResult_2 = 1;
                result_6 = matchValue_7;
            }
            else {
                matchResult_2 = 2;
            }
        }
        else if (matchValue_8 != null) {
            matchResult_2 = 2;
        }
        else {
            matchResult_2 = 0;
        }
        switch (matchResult_2) {
            case 0:
                return new StocktakingListTableRow(stocktakingListConsumable_1.ImageUrl, stocktakingListConsumable_1.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable_1.Unit)), stocktakingListConsumable_1.ConsumableName, "", "", "", stocktakingListConsumable_1.QRCodeIds, stocktakingListConsumable_1.StorageSpace, stocktakingListConsumable_1.Quantity.toString(), undefined, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(2, [stocktakingListConsumable_1.ConsumableId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListConsumable_1.ImageUrl, stocktakingListConsumable_1.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable_1.Unit)), stocktakingListConsumable_1.ConsumableName, "", "", "", stocktakingListConsumable_1.QRCodeIds, stocktakingListConsumable_1.StorageSpace, stocktakingListConsumable_1.Quantity.toString(), map((_arg_28) => _arg_28.RecordedBy, stocktakingListConsumable_1.Result), map((_arg_29) => _arg_29.Timestamp, stocktakingListConsumable_1.Result), map((arg_6) => arg_6.Quantity.toString(), stocktakingListConsumable_1.Result), map((_arg_31) => _arg_31.CorrectedBy, stocktakingListConsumable_1.Correction), map((_arg_32) => _arg_32.Timestamp, stocktakingListConsumable_1.Correction), map((arg_7) => arg_7.Quantity.toString(), stocktakingListConsumable_1.Correction), new StocktakingResultType(2, [stocktakingListConsumable_1.ConsumableId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.Consumables)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-2", "col-span-2"])], (elems_1 = toList(delay(() => append_1(singleton_1(createElement(ConfirmStocktakingResultDialog, {
        OnClose: () => {
            setIsConfirmStocktakingResultDialogOpen(undefined);
            props.Dispatch(new Msg(0, []));
            props.Dispatch(new Msg(1, []));
        },
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
        StocktakingResultType: unwrap(patternInput_1[0]),
    })), delay(() => append_1(singleton_1(createElement(CorrectionBookingDialog, {
        OnClose: () => {
            setIsCorrectionBookingDialogOpen(undefined);
            props.Dispatch(new Msg(0, []));
            props.Dispatch(new Msg(1, []));
        },
        Stocktaking: props.Stocktaking,
        StocktakingListId: props.StocktakingList.Id,
        StocktakingResultType: unwrap(patternInput_2[0]),
    })), delay(() => {
        let elems;
        const requiredActionsTranslation = t("stocktaking.required_actions");
        const overviewTranslation = t("general.overview");
        return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: toList(delay(() => {
                let matchValue_10, Label;
                return append_1((matchValue_10 = props.Stocktaking.State, (matchValue_10.tag === 1) ? (empty()) : ((matchValue_10.tag === 2) ? singleton_1((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "",
                })) : ((matchValue_10.tag === 3) ? singleton_1((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "",
                })) : ((matchValue_10.tag === 4) ? singleton_1((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "",
                })) : (empty()))))), delay(() => {
                    let Label_1;
                    return append_1(singleton_1((Label_1 = (`${overviewTranslation} (${length(overviewRows)})`), {
                        IsSelected: equals(selectedTab, new SelectedTab(1, [])),
                        Label: Label_1,
                        OnClick: () => {
                            setSelectedTab(new SelectedTab(1, []));
                        },
                        TestId: "",
                    })), delay(() => {
                        let Label_2;
                        return singleton_1((Label_2 = t("general.history"), {
                            IsSelected: equals(selectedTab, new SelectedTab(2, [])),
                            Label: Label_2,
                            OnClick: () => {
                                setSelectedTab(new SelectedTab(2, []));
                            },
                            TestId: "",
                        }));
                    }));
                }));
            })),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const matchValue_11 = selectedTab;
            switch (matchValue_11.tag) {
                case 2:
                    return singleton_1(createElement(ChangelogTable, {
                        Changelogs: props.Changelogs,
                    }));
                default:
                    return singleton_1(createElement(StocktakingListTable, {
                        Rows: (selectedTab.tag === 1) ? overviewRows : ((selectedTab.tag === 2) ? empty_1() : requiredActionsRows),
                        SelectedTab: selectedTab,
                        SetIsConfirmStocktakingResultDialogOpen: setIsConfirmStocktakingResultDialogOpen,
                        SetIsCorrectionBookingDialogOpen: setIsCorrectionBookingDialogOpen,
                        Stocktaking: props.Stocktaking,
                        StocktakingList: props.StocktakingList,
                    }));
            }
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function OverviewInformationSection(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-scope-name",
        Text: t("stocktaking.scope"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-scope-name-value",
        Text: props.StocktakingList.DisplayName,
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-affected-elements",
        Text: t("stocktaking.affected_elements"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-affected-elements-value",
        Text: int32ToString((length(props.StocktakingList.Tools) + length(props.StocktakingList.ToolsWithQuantity)) + length(props.StocktakingList.Consumables)),
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-helper",
        Text: t("stocktaking.stocktaking_helper"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-helper-value",
        Text: isEmpty(props.StocktakingList.Helper) ? "" : reduce((e1, e2) => concat(e1, ",", ...e2), map_1((helper) => helper.Name, props.StocktakingList.Helper)),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DetailsActions(props) {
    let elems_1, Title, Title_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_1 = [createElement(ConfirmationDialog, (Title = t("stocktaking.dialog.list.state_to_start_title"), {
        Description: t("stocktaking.dialog.list.state_to_start_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateStartDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(5, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(3, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("stocktaking.dialog.list.state_to_done_title"), {
        Description: t("stocktaking.dialog.list.state_to_done_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateDoneDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(6, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(4, []));
        },
        Title: Title_1,
    })), reactElement("div", {}), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7"])], (elems = toList(delay(() => {
        let Label, Label_1;
        const matchValue = props.Stocktaking.State;
        switch (matchValue.tag) {
            case 2: {
                const matchValue_1 = props.StocktakingList.State;
                switch (matchValue_1.tag) {
                    case 1:
                        return singleton_1(createElement(TextButton, (Label = t("stocktaking.list_state.to_done"), {
                            ComponentState: "enabled",
                            Icon: Shipment_Time(),
                            Label: Label,
                            OnClick: () => {
                                props.Dispatch(new Msg(6, [true]));
                            },
                            TestId: "stocktaking-list-done-state-button",
                            Variant: "default",
                        })));
                    case 0:
                        return singleton_1(createElement(TextButton, (Label_1 = t("stocktaking.list_state.to_start"), {
                            ComponentState: "enabled",
                            Icon: Shipment_Time(),
                            Label: Label_1,
                            OnClick: () => {
                                props.Dispatch(new Msg(5, [true]));
                            },
                            TestId: "stocktaking-list-start-state-button",
                            Variant: "default",
                        })));
                    default: {
                        return empty();
                    }
                }
            }
            default: {
                return empty();
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function OverviewSection(props) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [DetailsActions({
        DialogOpenState: props.DialogOpenState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-6"])], (elems = [createElement(OverviewInformationSection, {
        StocktakingList: props.StocktakingList,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StocktakingListDetailView(props) {
    let elems_3, elems_2, elems, elems_1;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "grid", "grid-cols-[max(75rem)_1fr]", "grid-rows-[auto_minmax(0,1fr)]", "gap-y-8"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(DetailViewHeader, {
        Badges: empty_1(),
        CustomBackButtonLabel: patternInput[0]("general.back"),
        OnBack: () => {
            RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id)]), 1, 1);
        },
        Title: props.StocktakingList.DisplayName,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(OverviewSection, {
        DialogOpenState: props.DialogOpenState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(StocktakingListOverviewSection, {
        Changelogs: props.Changelogs,
        Dispatch: props.Dispatch,
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function DetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init_1(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.StocktakingId, props.StocktakingListId], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Stocktaking;
    const matchValue_1 = state_1.StocktakingList;
    const matchValue_2 = state_1.Changelogs;
    let matchResult, changelogs, stocktaking, stocktakingList;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        changelogs = matchValue_2.fields[0];
        stocktaking = matchValue.fields[0];
        stocktakingList = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(StocktakingListDetailView, {
                Changelogs: changelogs,
                DialogOpenState: state_1.DialogOpenState,
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                Stocktaking: stocktaking,
                StocktakingList: stocktakingList,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

